import { customerServiceOrganizationsEntryPoint } from '@jira/jira-spa-apps-customer-service-organizations/entrypoint.tsx';
import { AsyncCustomersNav } from '@jira/jira-horizontal-nav-csm-customers/src/index.tsx';
import { l1CustomersProjectProviderResource } from '@jira/jira-router-resources-customer-service-l1-customers-project-provider/services/index.tsx';
import { csmCustomerContextTenantMigratedStatusResource } from '@jira/jira-router-resources-service-desk-customers-organizations-common/src/services/index.tsx';
import { customerServiceOrganizationsRoute } from '@atlassian/jira-router-routes-customer-services-customers-routes/src/customerServiceOrganizationsRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';

const customerServiceOrganizationsPageEntryPoint = createPageEntryPoint({
	main: customerServiceOrganizationsEntryPoint,
});

export const customerServiceOrganizationsRouteEntry = createEntry(
	customerServiceOrganizationsRoute,
	() => ({
		group: 'customer-service',
		perfMetricKey: 'customer-service.organizations',
		layout: globalLayout,

		navigation: {
			horizontal: AsyncCustomersNav,
		},

		component: ErrorPagesNotFound,

		entryPoint() {
			return fg('berry-6285-customers-l1') ? customerServiceOrganizationsPageEntryPoint : undefined;
		},

		resources: [
			...getNavigationResources(),
			l1CustomersProjectProviderResource,
			csmCustomerContextTenantMigratedStatusResource,
		],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-customer-services-customers-entries/src/customerServiceOrganizationsRouteEntry.tsx',
				whichExportToUse: 'customerServiceOrganizationsRouteEntry',
			},

			enabled: true,
		},
	}),
);
